import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Currently working for AWS as a senior solution architect, and also one of the initiators of the DDD Taiwan Community. Specializes in software system design, and is committed to the promotion of serverless services, and promotes enterprises to create more appropriate construction system solutions through DDD and convenient cloud services to solve real business problems.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      